module.exports = __webpack_public_path__ + "static/media/28.b8845288.svg";